import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var LayersOutlineSVG = function LayersOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29 13.91l-1.81-1 1.9-1.18a2 2 0 00-.09-3.4L17 1.76a2.13 2.13 0 00-2 0L3 8.33a2 2 0 000 3.4l1.9 1.18-1.9 1a2 2 0 000 3.4l1.82 1.13-1.82.95a2 2 0 000 3.4l11.94 7.39a2.09 2.09 0 002.22 0l11.94-7.39a2 2 0 00-.09-3.4l-1.73-.95 1.82-1.13a2 2 0 00-.1-3.4zM4.06 10.06L16 3.49l11.94 6.57-2.81 1.74-2 1.21L16 17.45 8.83 13l-2-1.21zm23.88 11.06L16 28.51 4.06 21.12l2.67-1.47 8.16 5.05a2.09 2.09 0 002.22 0l8.16-5.05zM16 23L4.06 15.64l2.75-1.52 8.08 5a2.09 2.09 0 002.22 0l8.08-5 2.75 1.52z"
  }));
};
LayersOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LayersOutlineSVG);